<template>
  <router-view/>
</template>

<style>
	/* 导入公共样式 @import固定格式引用css */
	@import url("assets/css/base.css");

</style>
